<template>
  <div>
    <div class="rj-search-category-wrapper">
      <button type="button" class="rj-search-category-dropdown-toggle">
        <div class="rj-search-category">
          <span class="rj-search-category-name">Mods</span>
          <i class="nmicon-chevron-down"></i>
        </div>
      </button>
      <ul class="rj-search-category-dropdown">
        <li
          class="rj-search-category-option category-selected"
          data-category-value="mods"
        >
          Mods
        </li>
        <li class="rj-search-category-option" data-category-value="games">
          Games
        </li>
        <li class="rj-search-category-option" data-category-value="images">
          Images
        </li>
        <li class="rj-search-category-option" data-category-value="videos">
          Videos
        </li>
        <li class="rj-search-category-option" data-category-value="authors">
          Users
        </li>
      </ul>
    </div>
    <div
      id="gsearch_results"
      class="hidden"
      style="display: none"
      tabindex="0"
    ></div>
    <button type="button" class="rj-search-button">
      <i class="material-icons">search</i>
    </button>

    <div class="rj-right-tray rj-upload-tray">
      <div class="arrow"></div>
      <ul class="rj-right-tray-content rj-upload-tray-content">
        <li class="rj-tray-section section-dark link-section">
          <a href="/">
            <div class="section-content">
              <i class="material-icons">cloud_upload</i>
              <span>UPLOAD A <strong>MOD</strong></span>
            </div>
          </a>
        </li>
        <li class="rj-tray-section section-dark link-section">
          <a href="/">
            <div class="section-content">
              <i class="material-icons">add_photo_alternate</i>
              <span>UPLOAD AN <strong>IMAGE</strong></span>
            </div>
          </a>
        </li>
        <li class="rj-tray-section section-dark link-section">
          <a href="/">
            <div class="section-content">
              <i class="material-icons">video_call</i>
              <span>ADD A <strong>VIDEO</strong></span>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="rj-right-tray rj-notifications-tray">
      <div class="arrow"></div>
      <div class="rj-right-tray-content rj-notifications-tray-content">
        <div class="notifications-content-wrapper">
          <div class="notifications-header">
            <div class="notifications-header-left">
              <i class="nmicon-notification"></i>
              <span>Notifications</span>
            </div>
            <div class="notifications-header-right">
              <button class="notifications-clear">
                Mark all as read (<span class="total-count">0</span>)
              </button>
            </div>
          </div>

          <div id="notifications-body" class="notifications-body">
            <div class="notifications-list">
              <div class="notifications-error">
                <button
                  class="notifications-error__banner js-refresh-notifications custom-button"
                  type="button"
                >
                  <i class="material-icons notifications-error__icon"
                    >error_outline</i
                  >
                  <div class="notifications-error__text">
                    <p class="notifications-error__header">
                      Oh dear! Something has gone wrong!
                    </p>
                    <p class="notifications-error__subheader">
                      Try reloading the notifications.
                    </p>
                  </div>
                  <i class="material-icons notifications-error__icon"
                    >refresh</i
                  >
                </button>
                <i class="material-icons notifications-error__placeholder"
                  >notifications_off</i
                >
              </div>
              <ul></ul>
              <div class="no-notifications">
                <i class="nmicon-notification"></i>
                <p>No unread notifications right now</p>
                <span>You're up to date</span>
              </div>
            </div>
            <div class="notification-load-more">
              <a
                href="/"
                class="rj-btn rj-btn-full rj-btn-outline notifications-load-more custom-button"
                type="button"
                >View All</a
              >
            </div>
            <div class="notification-up-to-date">
              <p>You're up to date</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rj-right-tray rj-profile-tray">
      <div class="arrow"></div>

      <ul class="rj-right-tray-content rj-profile-tray-content">
        <li class="user-profile-menu-section">
          <div class="section-content">
            <div class="profile-pic-wrapper">
              <div class="rj-profile-pic">
                <img
                  alt="Profile image"
                  src="https://avatars.nexusmods.com/100"
                />
              </div>
            </div>

            <div>
              <div class="user-profile-menu-username" title="guest">guest</div>

              <div>
                <span class="user-profile-menu-free-user">Free plan | </span>
                <a class="user-profile-menu-upgrade" href="/">Upgrade</a>
              </div>
            </div>
          </div>
        </li>

        <li class="user-profile-menu-divider"></li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/users/0">
            <div class="section-content">
              <i class="material-icons">account_circle</i> My profile
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/">
            <div class="section-content">
              <svg
                viewBox="0 0 24 24"
                role="presentation"
                class="flex-shrink-0"
                width="24"
                height="24"
              >
                <path
                  d="M11.985 17.8656L17.6972 13.4184L18.97 12.4328L11.985 7L5 12.4328L6.26506 13.4184L11.985 17.8656Z"
                  style="fill: currentcolor"
                ></path>
              </svg>

              My mods
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/">
            <div class="section-content">
              <svg
                viewBox="0 0 24 24"
                role="presentation"
                class="flex-shrink-0"
                width="24"
                height="24"
              >
                <path
                  d="M11.7229 15.369L6.21146 11.084L5 12.0262L11.7304 17.261L18.4607 12.0262L17.2418 11.0765L11.7229 15.369ZM11.7229 19.1079L6.21146 14.823L5 15.7652L11.7304 20.9999L18.4607 15.7652L17.2418 14.8155L11.7229 19.1079ZM11.7304 13.4694L17.2343 9.18445L18.4607 8.23472L11.7304 3L5 8.23472L6.21894 9.18445L11.7304 13.4694Z"
                  style="fill: currentcolor"
                ></path>
              </svg>

              My collections
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/users/myaccount?tab=images">
            <div class="section-content">
              <i class="material-icons-outlined">image</i> My media
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/modrewards#/wallet">
            <div class="section-content">
              <i class="material-icons">account_balance_wallet</i> My wallet
            </div>
          </a>
        </li>

        <li class="user-profile-menu-divider"></li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/mods/trackingcentre">
            <div class="section-content">
              <svg
                viewBox="0 0 24 24"
                role="presentation"
                class="flex-shrink-0"
                width="24"
                height="24"
              >
                <path
                  d="M13.7521 11.5118C13.7521 10.1394 15.7161 7.96661 17.1112 7.96661C18.5069 7.96661 20.4704 10.1412 20.4852 11.5127C20.4852 12.1302 19.9993 12.4999 19.2241 12.4999C18.7783 12.4999 18.4095 12.3774 18.0593 12.261C17.7425 12.1557 17.441 12.0555 17.1112 12.0555C16.7866 12.0555 16.4886 12.1546 16.1742 12.2593C15.8229 12.3762 15.451 12.4999 14.9984 12.4999C14.2066 12.4999 13.7366 12.1298 13.7521 11.5118ZM13.2648 6.85595C13.7767 6.73199 14.3415 7.13043 14.5237 7.74349C14.7048 8.3562 14.4395 8.95474 13.9277 9.0787C13.4158 9.20265 12.851 8.80422 12.6687 8.18974C12.4864 7.57703 12.7529 6.9799 13.2648 6.85595ZM16.6191 5.72173C16.8277 6.50568 16.5552 7.23127 16.0126 7.37515C15.4677 7.52036 14.8595 7.01213 14.6505 6.24412C14.4418 5.46018 14.7143 4.73458 15.2569 4.5907C15.8017 4.46266 16.4104 4.93778 16.6191 5.72173ZM19.7001 7.74384C19.8824 7.13078 20.4472 6.74828 20.9591 6.8563C21.4548 6.98026 21.736 7.57703 21.5545 8.19098C21.3699 8.80404 20.8074 9.18654 20.2955 9.07852C19.7836 8.95456 19.5179 8.35708 19.7001 7.74384ZM19.572 6.24412C19.3633 7.01213 18.739 7.51904 18.2099 7.37515C17.6667 7.23172 17.3942 6.48974 17.6034 5.72173C17.8121 4.95372 18.4365 4.44682 18.9656 4.5907C19.5083 4.73449 19.7807 5.47611 19.572 6.24412ZM4.75206 19.4452C4.75206 18.0728 6.71607 15.9 8.11124 15.9C9.50694 15.9 11.4704 18.0745 11.4852 19.4461C11.4852 20.0635 10.9993 20.4333 10.2241 20.4333C9.77829 20.4333 9.40952 20.3107 9.05928 20.1943C8.74255 20.0891 8.44097 19.9888 8.11124 19.9888C7.78661 19.9888 7.48864 20.088 7.17418 20.1926C6.82288 20.3095 6.45099 20.4333 5.99835 20.4333C5.20663 20.4333 4.73659 20.0632 4.75206 19.4452ZM4.2648 14.7893C4.77667 14.6653 5.34146 15.0638 5.52374 15.6768C5.7048 16.2895 5.43954 16.8881 4.92767 17.012C4.41579 17.136 3.85101 16.7376 3.66872 16.1231C3.48637 15.5104 3.75292 14.9133 4.2648 14.7893ZM7.61905 13.6551C7.82771 14.439 7.55524 15.1646 7.01261 15.3085C6.46769 15.4537 5.85948 14.9455 5.65048 14.1775C5.44183 13.3935 5.71429 12.6679 6.25692 12.524C6.80167 12.396 7.4104 12.8711 7.61905 13.6551ZM10.7001 15.6772C10.8824 15.0641 11.4472 14.6816 11.9591 14.7896C12.4548 14.9136 12.736 15.5104 12.5545 16.1243C12.3699 16.7374 11.8074 17.1199 11.2955 17.0119C10.7836 16.8879 10.5179 16.2904 10.7001 15.6772ZM10.572 14.1775C10.3634 14.9455 9.73898 15.4524 9.20987 15.3085C8.66671 15.1651 8.39425 14.4231 8.60343 13.6551C8.81208 12.8871 9.43646 12.3802 9.96556 12.524C10.5083 12.6678 10.7807 13.4095 10.572 14.1775Z"
                  style="fill: currentcolor"
                ></path>
              </svg>

              Tracking centre
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/users/myaccount?tab=download+history">
            <div class="section-content">
              <i class="material-icons">history</i> Download history
            </div>
          </a>
        </li>

        <li class="user-profile-menu-divider"></li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/" rel="noreferrer" target="_blank">
            <div class="section-content">
              <svg
                viewBox="0 0 24 24"
                role="presentation"
                class="flex-shrink-0"
                width="24"
                height="24"
              >
                <path
                  d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                  style="fill: currentcolor"
                ></path>
              </svg>

              Give feedback
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/">
            <div class="section-content">
              <i class="material-icons">settings</i> Account settings
            </div>
          </a>
        </li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <a href="/">
            <div class="section-content">
              <i class="material-icons">tune</i> Site preferences
            </div>
          </a>
        </li>

        <li class="user-profile-menu-divider"></li>

        <li class="user-profile-menu-section user-profile-menu-section--link">
          <form action="/">
            <button type="submit" role="link" class="section-content">
              <i class="material-icons">exit_to_app</i> Sign out
            </button>
          </form>
        </li>
      </ul>
    </div>
    <header id="head" class="new-head">
      <div class="rj-header-wrap">
        <a class="skip-to-content" href="#mainContent">Skip to content</a>
        <a class="headlogo" href="/" alt="Nexus Mods" title="Nexus Mods home">
          <!-- <div>
            <img :src="topLogo" />
          </div> -->
        </a>
        <div class="rj-nav nav-alignment">
          <button
            class="nav-tab-button"
            v-for="item in meunList"
            :key="item"
            :data-title="item.name"
            @click="clickMenu(item)"
          >
            {{ item.name }}
          </button>
        </div>

        <form class="rj-search" method="POST" action="/">
          <input
            id="gsearch"
            class="rj-search-input"
            name="gsearch"
            data-url="/"
            type="text"
            placeholder="Search"
            autocomplete="off"
            aria-label="Search"
          />
          <input
            id="searchtype"
            type="hidden"
            name="gsearchtype"
            value="mods"
          />
          <!--                <i class="material-icons">search</i>-->
          <div class="rj-search-category-wrapper">
            <button type="button" class="rj-search-category-dropdown-toggle">
              <div class="rj-search-category">
                <span class="rj-search-category-name">Mods</span>
              </div>
            </button>
            <ul class="rj-search-category-dropdown">
              <li
                class="rj-search-category-option category-selected"
                data-category-value="mods"
              >
                Mods
              </li>
              <li class="rj-search-category-option" data-category-value="games">
                Games
              </li>
              <li
                class="rj-search-category-option"
                data-category-value="images"
              >
                Images
              </li>
              <li
                class="rj-search-category-option"
                data-category-value="videos"
              >
                Videos
              </li>
              <li
                class="rj-search-category-option"
                data-category-value="authors"
              >
                Users
              </li>
            </ul>
          </div>
          <div
            id="gsearch_results"
            class="hidden"
            style="display: none"
            tabindex="0"
          ></div>
          <button type="button" class="rj-search-button">
            <i class="material-icons">search</i>
          </button>
        </form>

        <div class="rj-login-nav">
          <a
            id="login"
            class="rj-btn rj-btn-clear"
            href="/"
            title="Log in to Nexus Mods"
            tabindex="0"
            >Log in</a
          >
          <a class="rj-btn rj-btn-standard" href="/">Register</a>
        </div>
      </div>
    </header>

    <div class="wrapper" id="mainContent">
      <iframe
        id="gameFrame"
        class="game-frame"
        :src="frameUrl"
        title="War Checkers"
        frameborder="0"
        allowfullscreen=""
      ></iframe>
      <section class="static gameindex">
        <div class="collections-banner-outer-wrapper-trigger">
          <div class="collections-banner-wrapper">
            <a
              class="collections-banner"
              href="/"
              data-tracking='["Game Page","View Collections"]'
            >
              <div class="collections-banner__splash">
                <img
                  class="collections-banner__splash-image"
                  src="https://www.nexusmods.com/assets/images/collections-banner-splash.png"
                  role="presentation"
                  alt=""
                />
              </div>
              <i class="user-profile-menu-icon-collections"></i>
              <span
                >Download <strong>1,432 Collections</strong> for
                <strong>Cyberpunk 2077</strong></span
              >
              <i class="material-icons">chevron_right</i>
            </a>
          </div>
        </div>

        <section class="premium-block premium-block--register background-1">
          <div class="premium-block__text-wrapper">
            <h2>Join Us</h2>
          </div>
          <div class="premium-block__link-wrapper">
            <a class="rj-btn rj-btn-standard" href="/"><span>Register</span></a>
            <span>Already have an account? <a href="/">Log in here</a></span>
          </div>
        </section>

        <div class="wrap tab-block clearfix" id="game-mods">
          <div class="col-1-1">
            <div class="tab-head clearfix">
              <h2>More mods</h2>
              <a
                href="/"
                class="view-all"
                data-tracking='["Game Page","View All mods"]'
              >
                Explore all mods
              </a>
            </div>
            <div class="tabs">
              <!-- <ul class="modtabs">
                <li title="Mods uploaded today">
                  <a
                    class="selected"
                    href="/cyberpunk2077?tab=new+today"
                    data-target="/cyberpunk2077/mods/today/?nav=0&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","New today"]'
                  >
                    <span class="tab-label">New today</span>
                    <span class="alert">16</span>
                  </a>
                </li>
                <li title="Mods uploaded this week">
                  <a
                    href="/cyberpunk2077?tab=new+this+week"
                    data-target="/cyberpunk2077/mods/thisweek/?nav=0&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","New this week"]'
                  >
                    <span class="tab-label">New this week</span>
                    <span class="alert">110</span>
                  </a>
                </li>
                <li title="Most downloaded mods in the last 30 days">
                  <a
                    href="/cyberpunk2077?tab=popular+%2830+days%29"
                    data-target="/cyberpunk2077/mods/popular/?nav=0&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","Popular (30 days)"]'
                  >
                    <span class="tab-label">Popular (30 days)</span>
                  </a>
                </li>
                <li title="Most downloaded mods">
                  <a
                    href="/cyberpunk2077?tab=popular+%28all+time%29"
                    data-target="/cyberpunk2077/mods/popularalltime/?nav=0&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","Popular (all time)"]'
                  >
                    <span class="tab-label">Popular (all time)</span>
                  </a>
                </li>
                <li
                  title="Mods ranked by the number of endorsements received in the last 7 days"
                >
                  <a
                    href="/cyberpunk2077?tab=more+trending"
                    data-target="/cyberpunk2077/mods/moretrending/?nav=0&amp;skip=7&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","More Trending"]'
                  >
                    <span class="tab-label">More Trending</span>
                  </a>
                </li>
                <li title="Random mods">
                  <a
                    href="/cyberpunk2077?tab=random"
                    data-target="/cyberpunk2077/mods/random/?nav=0&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","Random"]'
                  >
                    <span class="tab-label">Random</span>
                  </a>
                </li>
                <li title="Mods updated recently">
                  <a
                    href="/cyberpunk2077?tab=updated"
                    data-target="/cyberpunk2077/mods/updated/?nav=0&amp;page_size=15"
                    data-tracking='["Game Page","Click Mod Tab","Updated"]'
                  >
                    <span class="tab-label">Updated</span>
                  </a>
                </li>
              </ul> -->
              <div class="mobile-tabs">
                <div class="navlabel">Current section</div>
                <ul class="tabs-clone">
                  <li>
                    <a class="clearfix">
                      <strong>Viewing:</strong>
                      <span class="tab-view"></span>
                      <svg title="" class="icon-arrow">
                        <use
                          xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-arrow"
                        ></use>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tabcontent">
                <div id="mod-list" class="container">
                  <span></span>
                  <ul class="tiles">
                    <li
                      class="mod-tile"
                      v-for="item in gameList"
                      :key="item"
                      @click="navigateToGame(item.aHerf)"
                    >
                      <div id="mod-tile-gallery-3333-20249"></div>

                      <div
                        data-mod-id="20249"
                        data-game-id="3333"
                        data-tracking='["Game Page","View Mod","New Today"]'
                        class="mod-tile-left"
                      >
                        <figure class="image_figure">
                          <img
                            class="back"
                            :src="item.gameImageUrl"
                            width="600"
                            height="338"
                            alt=""
                          />
                          <div class="fore_div_mods">
                            <img
                              class="fore"
                              loading="lazy"
                              :src="item.gameImageUrl"
                              :alt="item.gameName"
                            />
                          </div>
                        </figure>

                        <div class="tile-desc motm-tile">
                          <div class="fadeoff"></div>
                          <div class="tile-content">
                            <p class="tile-name">
                              <a href="/">{{ item.gameName }}</a>
                            </p>
                            <!-- <div class="meta clearfix">
                              <time class="date" datetime="2025-03-10 09:46">
                                <span class="label">Uploaded: </span> 10 Mar
                                2025
                              </time>
                              <div class="date">
                                <span class="label">Last Update:</span> 10 Mar
                                2025
                              </div>
                              <div class="realauthor">
                                <span class="label">Author: </span>
                                yellingintothevoid
                              </div>
                              <div class="author">
                                <span class="label">Uploader: </span>
                                <a
                                  href="/"
                                  data-tracking='["Game Page","View Mod Author","yellingintothevoid"]'
                                  >yellingintothevoid</a
                                >
                              </div>
                            </div>
                            <p class="desc">
                              comes in 15 appearances, three of which are
                              liveries, and a bunch of tuning parts which can be
                              chosen with the fomod installer for Vortex.
                            </p> -->
                          </div>
                        </div>

                        <!-- <div class="tile-data">
                          <ul class="clearfix">
                            <li class="sizecount inline-flex">
                              <span class="flex-label"> 78.1MB </span>
                            </li>
                            <li class="downloadcount inline-flex">
                              <span class="flex-label"> -- </span>
                            </li>
                          </ul>
                        </div> -->
                      </div>
                      <div class="mod-tile-right">
                        <div class="tile-desc">
                          <div class="fadeoff"></div>
                          <div class="tile-content">
                            <p class="tile-name">
                              <a href="/">Honda S2000 - ArchiveXL</a>
                            </p>
                            <div class="meta clearfix">
                              <div class="category">
                                <a
                                  href="/"
                                  data-tracking='["Game Page","View Mod Category","Vehicles"]'
                                  >Vehicles</a
                                >
                              </div>
                              <time class="date" datetime="2025-03-10 09:46">
                                <span class="label">Uploaded: </span> 10 Mar
                                2025
                              </time>
                              <div class="date">
                                <span class="label">Last Update:</span> 10 Mar
                                2025
                              </div>
                              <div class="author">
                                <span class="label">Author: </span
                                ><a href="/">yellingintothevoid</a>
                              </div>
                            </div>
                            <p class="desc">
                              comes in 15 appearances, three of which are
                              liveries, and a bunch of tuning parts which can be
                              chosen with the fomod installer for Vortex.
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="clearfix" style="text-align: center; background: #2d2d2d">
          <div class="ads">
            <amp-ad
              width="100vw"
              height="320"
              type="adsense"
              :data-ad-client="clientId"
              :data-ad-slot="clientslotId"
              data-auto-format="rspv"
              data-full-width=""
            >
              <div overflow=""></div>
            </amp-ad>
            <div id="ad-container" align="center"></div>
          </div>
        </div>

        <div class="wrap tab-block clearfix">
          <div class="col-1-1">
            <div class="tab-head clearfix">
              <h2>News &amp; Updates</h2>
            </div>
            <div class="tabs">
              <!-- <ul class="modtabs">
                <li title="All news">
                  <a
                    class="selected"
                    href="/cyberpunk2077?tab=all+news"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=0"
                    data-tracking='["Game Page","Click News Tab","All news"]'
                  >
                    <span class="tab-label">All news</span>
                  </a>
                </li>
                <li title="Features">
                  <a
                    href="/cyberpunk2077?tab=features"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=110"
                    data-tracking='["Game Page","Click News Tab","Features"]'
                  >
                    <span class="tab-label">Features</span>
                  </a>
                </li>
                <li title="Site news">
                  <a
                    href="/cyberpunk2077?tab=site+news"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=100"
                    data-tracking='["Game Page","Click News Tab","Site news"]'
                  >
                    <span class="tab-label">Site news</span>
                  </a>
                </li>
                <li title="Game news">
                  <a
                    href="/cyberpunk2077?tab=game+news"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=103"
                    data-tracking='["Game Page","Click News Tab","Game news"]'
                  >
                    <span class="tab-label">Game news</span>
                  </a>
                </li>
                <li title="Competition news">
                  <a
                    href="/cyberpunk2077?tab=competition+news"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=111"
                    data-tracking='["Game Page","Click News Tab","Competition news"]'
                  >
                    <span class="tab-label">Competition news</span>
                  </a>
                </li>
                <li title="Mod news">
                  <a
                    href="/cyberpunk2077?tab=mod+news"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=101"
                    data-tracking='["Game Page","Click News Tab","Mod news"]'
                  >
                    <span class="tab-label">Mod news</span>
                  </a>
                </li>
                <li title="Interviews">
                  <a
                    href="/cyberpunk2077?tab=interviews"
                    data-target="/Core/Libs/Common/Widgets/NewsTabContent?game_id=3333&amp;page_size=12&amp;nav=0&amp;category_id=105"
                    data-tracking='["Game Page","Click News Tab","Interviews"]'
                  >
                    <span class="tab-label">Interviews</span>
                  </a>
                </li>
                <li title="Articles by mod authors">
                  <a
                    href="/cyberpunk2077?tab=mod+updates"
                    data-target="/Core/Libs/Common/Widgets/ModArticlesTab?game_id=3333&amp;page=1&amp;nav=0"
                    data-tracking='["Game Page","Click News Tab","Mod updates"]'
                  >
                    <span class="tab-label">Mod updates</span>
                  </a>
                </li>
              </ul> -->
              <div class="mobile-tabs">
                <div class="navlabel">Current section</div>
                <ul class="tabs-clone">
                  <li>
                    <a class="clearfix">
                      <strong>Viewing:</strong>
                      <span class="tab-view"></span>
                      <svg title="" class="icon-arrow">
                        <use
                          xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-arrow"
                        ></use>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tabcontent">
                <div id="news-container">
                  <span></span>
                  <div class="container" id="news-content">
                    <ul class="tiles">
                      <li
                        class="article-tile"
                        v-for="item in gameBottomList"
                        :key="item"
                      >
                        <div class="mod-tile-left">
                          <div class="clearfix single-image">
                            <div class="fadeoff image_fade"></div>
                            <a class="mod-image" href="/">
                              <img
                                loading="lazy"
                                :src="item.gameImageUrl"
                                alt=""
                                title="C3: Community Creations Con"
                              />
                            </a>
                          </div>
                          <div class="tile-desc">
                            <div class="fadeoff"></div>
                            <div class="tile-content">
                              <p class="tile-name">
                                <a href="/">{{ item.gameName }}</a>
                              </p>
                              <!-- <div class="meta clearfix">
                                <time class="date" datetime="2025-02-19 13:55">
                                  19 Feb 2025
                                </time>
                                <div class="author">
                                  <a href="/">SlugGirl</a>
                                </div>
                              </div>
                              <p class="desc">
                                C3: Community Creations Con is back this Friday
                                21 to Saturday 22 of February! As many of you
                                will know, this virtual convention is a
                                celebration of the incredible talent within our
                                modding community, showcasing a diverse range of
                                creations across Fallout, Elder Scrolls, and
                                Starfield.
                                <br />
                                <br />C3 is an annual community-driven event,
                                planned and organised this year by Elianora and
                                Kate Aces. It’s something we here at Nexus Mods
                                are incredibly proud to support and help
                                promote.
                                <br />
                                <br />
                              </p> -->
                            </div>
                          </div>
                          <!-- <div class="tile-data">
                            <ul class="clearfix">
                              <li class="inline-flex">
                                <svg title="" class="icon icon-comment">
                                  <use
                                    xlink:href="https://www.nexusmods.com/assets/images/icons/icons.svg#icon-comment"
                                  ></use>
                                </svg>
                                <span
                                  class="flex-label comment-count"
                                  data-comment-count="15"
                                  >15 Comments</span
                                >
                              </li>
                            </ul>
                          </div> -->
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="clearfix" style="text-align: center; background: #2d2d2d">
        <div class="ads">
          <amp-ad
            width="100vw"
            height="320"
            type="adsense"
            :data-ad-client="clientId"
            :data-ad-slot="clientslotId"
            data-auto-format="rspv"
            data-full-width=""
          >
            <div overflow=""></div>
          </amp-ad>
          <div id="ad-container2" align="center"></div>
        </div>
      </div>
      <div id="rj-back-to-top" title="Back to top">
        <i class="fa fa-chevron-up"></i>
      </div>
    </div>
    <footer id="rj-footer">
      <section id="rj-vortex">
        <div class="content rj-grid-12">
          <div
            class="rj-vortex-icon-wrapper col-md-6-12 col-md-pad-2-12 col-lg-4-12 col-lg-pad-3-12"
          >
            <!-- <img class="rj-vortex-icon icon" alt="Vortex" :src="bottomLogo" /> -->
            <span class="rj-vortex-name">{{ proName }}</span>
            <div class="rj-vortex-description">
              The powerful open-source mod manager from {{ proName }}.
            </div>
          </div>
          <div class="col-md-2-12 col-md-pad-8-12 col-lg-pad-7-12">
            <form action="/" class="rj-button-form">
              <button class="rj-vortex-button">Learn more</button>
            </form>
          </div>
        </div>
      </section>

      <section id="rj-sitemap">
        <div class="content rj-grid-12">
          <div class="rj-sitemap-category col-sm-3-12 col-md-2-12">
            <h3>{{ proName }} <i class="rj-chevron fa fa-chevron-down"></i></h3>

            <ul>
              <li>
                <a href="/s">News</a>
              </li>
              <li>
                <a href="/">Statistics</a>
              </li>
              <li>
                <a href="/">Careers</a>
              </li>
              <li><a href="/">About us</a></li>
              <li>
                <a href="/">Premium features</a>
              </li>
            </ul>
          </div>

          <div
            class="rj-sitemap-category col-sm-pad-3-12 col-sm-3-12 col-md-pad-2-12 col-md-2-12"
          >
            <h3>Discover <i class="rj-chevron fa fa-chevron-down"></i></h3>

            <ul>
              <li>
                <a href="/">All games</a>
              </li>
              <li>
                <a href="/">All mods</a>
              </li>
              <li>
                <a href="/">New mods</a>
              </li>
              <li>
                <a href="/">Popular mods</a>
              </li>
              <li>
                <a href="/g">Trending mods</a>
              </li>
              <li>
                <a href="/">All collections</a>
              </li>
              <li>
                <a href="/">All images</a>
              </li>
            </ul>
          </div>

          <div
            class="rj-sitemap-category col-sm-pad-6-12 col-sm-3-12 col-md-pad-4-12 col-md-2-12"
          >
            <h3>Support {{ proName }}</h3>
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Help</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Wiki</a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://app.swaggerhub.com/apis-docs/NexusMods/nexus-mods_public_api_params_in_form_data/1.0#/"
                  >API reference</a
                >
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Give feedback</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Report a bug</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Unban requests</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">DMCA</a>
              </li>
              <li>
                <a class="nn-cmp-show" href="#">Manage cookie settings</a>
              </li>
            </ul>
          </div>
          <div
            class="rj-sitemap-category rj-sitemap-category-no-border col-sm-pad-9-12 col-sm-3-12 col-md-pad-6-12 col-md-2-12 col-xl-3-12"
          >
            <h3>Community <i class="rj-chevron fa fa-chevron-down"></i></h3>
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Forums</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Discord</a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.patreon.com/nexusmods"
                  >Support authors</a
                >
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="/">Contact us</a>
              </li>
            </ul>
          </div>
          <div
            class="col-sm-pad-3-12 col-sm-6-12 col-md-pad-8-12 col-md-4-12 col-xl-pad-9-12 col-xl-3-12"
          >
            <div class="rj-supporter-wrapper">
              <h3>Support Nexus Mods</h3>
              <ul id="footbtn" class="clearfix">
                <li>
                  <a href="/" class="rj-standard-button">Go premium</a>
                </li>
              </ul>
            </div>
            <div class="rj-network-stats">
              <h3>Network Stats</h3>
              <ul id="networkstats" class="rj-grid-12 rj-grid-small-gap">
                <li class="col-md-6-12 col-lg-4-12">
                  <h4>Members</h4>
                  <div class="stat total_members">60,198,742</div>
                </li>
                <li
                  class="col-md-pad-6-12 col-md-6-12 col-lg-pad-4-12 col-lg-4-12"
                >
                  <h4>Mods</h4>
                  <div class="stat total_mods">675,254</div>
                </li>
                <li
                  class="row-md-2 col-md-6-12 row-lg-1 col-lg-pad-8-12 col-lg-4-12"
                >
                  <h4>Kudos given</h4>
                  <div class="stat total_kudos">3,094,312</div>
                </li>
                <li class="row-md-3 col-md-6-12 col-lg-12-12">
                  <h4>Page served in</h4>
                  <div class="stat served_time">0.071s</div>
                  <div class="stat" title="nexusmods-7fd699cfcc-szr7b">
                    v2.14.1074 | UK 1
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="rj-logo-social">
        <div class="content rj-grid-12">
          <div class="rj-logo-wrapper col-xs-1-12 col-sm-6-12">
            <!-- <a class="headlogo" href="/" title="Nexus Mods">
              <img :src="topLogo" />
            </a> -->
          </div>
        </div>
      </section>
      <section id="rj-foot">
        <div class="content">
          <span class="rj-copyright"
            >Copyright &copy; 2025 Black Tree Gaming Ltd. All rights
            reserved.</span
          >
          <div class="rj-foot-links">
            <a target="_blank" rel="noreferrer" href="/">Terms of Service</a>
            |
            <a target="_blank" rel="noreferrer" href="/">Privacy Policy</a>
          </div>
        </div>
      </section>
    </footer>
  </div>
</template>
<script setup>
import { ref, created, onMounted, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const bottomLogo = require("@/assets/image/logo.jpg");
const topLogo = require("@/assets/image/logo-white.png");
// 菜单列表
const meunList = [
  {
    name: "Games",
    skipUrl: "/",
  },
  {
    name: "Mods",
    skipUrl: "/",
  },
  {
    name: "Collections",
    skipUrl: "/",
  },
  {
    name: "Media",
    skipUrl: "/",
  },
  {
    name: "Community",
    skipUrl: "/",
  },
  {
    name: "Support",
    skipUrl: "/",
  },
];
// 游戏列表
const gameList = ref([
  {
    gameName: "Paper Doll Fo",
    aHerf: "1",
    gameImageUrl: require("@/assets/image/gameImg/y1.png"),
    bigFlag: false,
    alt: "Paper Doll For Girls Dress Up",
    score: "8.0bn",
  },
  {
    gameName: "Color Link Challenge",
    aHerf: "2",
    gameImageUrl: require("@/assets/image/gameImg/y2.png"),
    bigFlag: false,
    alt: "Color Link Challenge",
    score: "8.0bn",
  },
  {
    gameName: "Car Jam Color",
    aHerf: "3",
    gameImageUrl: require("@/assets/image/gameImg/y3.png"),
    bigFlag: true,
    alt: "Car Jam Color",
    score: "8.0bn",
  },
  {
    gameName: "Happy Glass",
    aHerf: "4",
    gameImageUrl: require("@/assets/image/gameImg/y4.png"),
    bigFlag: false,
    alt: "Happy Glass",
    score: "8.0bn",
  },
  {
    gameName: "Slide Blocks",
    aHerf: "5",
    gameImageUrl: require("@/assets/image/gameImg/y5.png"),
    bigFlag: false,
    alt: "Slide Blocks Puzzle",
    score: "7.8bn",
  },
  {
    gameName: "Cannon Balls",
    aHerf: "6",
    gameImageUrl: require("@/assets/image/gameImg/y6.png"),
    bigFlag: false,
    alt: "Cannon Balls - Arcade",
    score: "7.8bn",
  },
  {
    gameName: "Basketball Sw",
    aHerf: "7",
    gameImageUrl: require("@/assets/image/gameImg/y7.png"),
    bigFlag: false,
    alt: "Basketball Swooshes",
    score: "7.8bn",
  },
  {
    gameName: "Build Tower",
    aHerf: "8",
    gameImageUrl: require("@/assets/image/gameImg/y8.png"),
    bigFlag: false,
    alt: "Build Tower",
    score: "7.8bn",
  },
  {
    gameName: "Mushroom Pop",
    aHerf: "9",
    gameImageUrl: require("@/assets/image/gameImg/y9.png"),
    bigFlag: false,
    alt: "Mushroom Pop",
    score: "7.8bn",
  },
  {
    gameName: "Jumper Bot",
    aHerf: "10",
    gameImageUrl: require("@/assets/image/gameImg/y10.png"),
    bigFlag: false,
    alt: "Jumper Bot",
    score: "7.8bn",
  },
  {
    gameName: "Ghost Float",
    aHerf: "11",
    gameImageUrl: require("@/assets/image/gameImg/y11.png"),
    bigFlag: false,
    alt: "Ghost Float",
    score: "7.6bn",
  },
  {
    gameName: "Flamingo Bing",
    aHerf: "12",
    gameImageUrl: require("@/assets/image/gameImg/y12.png"),
    bigFlag: false,
    alt: "Flamingo Bingo",
    score: "7.6bn",
  },
  {
    gameName: "Zombie Wipeou",
    aHerf: "13",
    gameImageUrl: require("@/assets/image/gameImg/y13.png"),
    bigFlag: false,
    alt: "Zombie Wipeout",
    score: "7.6bn",
  },
  {
    gameName: "Dd Pixel Slid",
    aHerf: "14",
    gameImageUrl: require("@/assets/image/gameImg/y14.png"),
    bigFlag: true,
    alt: "Dd Pixel Slide",
    score: "7.6bn",
  },
  {
    gameName: "Swipe The Pin",
    aHerf: "15",
    gameImageUrl: require("@/assets/image/gameImg/y15.png"),
    bigFlag: false,
    alt: "Swipe The Pin",
    score: "7.6bn",
  },
]);
const proName = process.env.VUE_APP_PROJECTNAME;

// 底部游戏列表
const gameBottomList = ref([
  {
    gameName: "Fire And Wate",
    aHerf: "21",
    gameImageUrl: require("@/assets/image/gameImg/y21.png"),
    bigFlag: false,
    alt: "Fire And Water Stickman",
    viewNum: 5555,
    score: "8.0bn",
  },
  {
    gameName: "2048 Champion",
    aHerf: "22",
    gameImageUrl: require("@/assets/image/gameImg/y22.png"),
    bigFlag: true,
    alt: "2048 Champion",
    viewNum: 2137,
    score: "7.8bn",
  },
  {
    gameName: "Clones",
    aHerf: "23",
    gameImageUrl: require("@/assets/image/gameImg/y23.png"),
    bigFlag: false,
    alt: "Clones",
    viewNum: 1555,
    score: "7.6bn",
  },
  {
    gameName: "Firefighter R",
    aHerf: "24",
    gameImageUrl: require("@/assets/image/gameImg/y24.png"),
    bigFlag: false,
    alt: "Firefighter Rescue Quest",
    viewNum: 780,
    score: "7.6bn",
  },
  {
    gameName: "Dragon's Defe",
    aHerf: "25",
    gameImageUrl: require("@/assets/image/gameImg/y25.png"),
    bigFlag: false,
    alt: "Dragon's Defense Reign Of Fire",
    viewNum: 1323,
    score: "5.6bn",
  },
  {
    gameName: "Chin Up Shin",
    aHerf: "26",
    gameImageUrl: require("@/assets/image/gameImg/y26.png"),
    bigFlag: true,
    alt: "Chin Up Shin Up",
    viewNum: 1209,
    score: "6.1bn",
  },
  {
    gameName: "Counter Craft",
    aHerf: "27",
    gameImageUrl: require("@/assets/image/gameImg/y27.png"),
    bigFlag: false,
    alt: "Counter Craft 5",
    viewNum: 879,
    score: "7.2bn",
  },
  {
    gameName: "The Bomb",
    aHerf: "28",
    gameImageUrl: require("@/assets/image/gameImg/y28.png"),
    bigFlag: true,
    alt: "The Bomb",
    viewNum: 860,
    score: "7.7bn",
  },
  {
    gameName: "Princesses At",
    aHerf: "29",
    gameImageUrl: require("@/assets/image/gameImg/y29.png"),
    bigFlag: false,
    alt: "Princesses At Horror School",
    viewNum: 531,
    score: "7.9bn",
  },
  {
    gameName: "Number Match",
    aHerf: "30",
    gameImageUrl: require("@/assets/image/gameImg/y30.png"),
    bigFlag: false,
    alt: "Number Match - Match Ten",
    viewNum: 768,
    score: "7.5bn",
  },
  {
    gameName: "Ultimate Noug",
    aHerf: "31",
    gameImageUrl: require("@/assets/image/gameImg/y31.png"),
    bigFlag: false,
    alt: "Ultimate Noughts &amp; Crosses",
    viewNum: 980,
    score: "7.1bn",
  },
  {
    gameName: "Arrowblob Puz",
    aHerf: "32",
    gameImageUrl: require("@/assets/image/gameImg/y32.png"),
    bigFlag: false,
    alt: "Arrowblob Puzzle Quest",
    viewNum: 988,
    score: "6.2bn",
  },
  {
    gameName: "Ascend",
    aHerf: "33",
    gameImageUrl: require("@/assets/image/gameImg/y33.png"),
    bigFlag: false,
    alt: "Ascend",
    viewNum: 586,
    score: "5.6bn",
  },
  {
    gameName: "Race",
    aHerf: "34",
    gameImageUrl: require("@/assets/image/gameImg/y34.png"),
    bigFlag: false,
    alt: "Race",
    viewNum: 245,
    score: "8.6bn",
  },
  {
    gameName: "Tanks Battle",
    aHerf: "35",
    gameImageUrl: require("@/assets/image/gameImg/y35.png"),
    bigFlag: false,
    alt: "Tanks Battle Field",
    viewNum: 856,
    score: "8.6bn",
  },
  {
    gameName: "Battlegrid On",
    aHerf: "36",
    gameImageUrl: require("@/assets/image/gameImg/y36.png"),
    bigFlag: false,
    alt: "Battlegrid Online Pvp Tank Battles",
    viewNum: 153,
    score: "8.8bn",
  },
  {
    gameName: "Pumpkin Of Go",
    aHerf: "37",
    gameImageUrl: require("@/assets/image/gameImg/y37.png"),
    bigFlag: false,
    alt: "Pumpkin Of Goo",
    viewNum: 122,
    score: "8.6bn",
  },
  {
    gameName: "Apostle's Cre",
    aHerf: "38",
    gameImageUrl: require("@/assets/image/gameImg/y38.png"),
    bigFlag: false,
    alt: "Apostle's Creed I",
    viewNum: 436,
    score: "7.9bn",
  },
  {
    gameName: "Zombie Runner",
    aHerf: "39",
    gameImageUrl: require("@/assets/image/gameImg/y39.png"),
    bigFlag: true,
    alt: "Zombie Runner",
    viewNum: 1152,
    score: "7.8bn",
  },
  {
    gameName: "Fruit Name Ju",
    aHerf: "40",
    gameImageUrl: require("@/assets/image/gameImg/y40.png"),
    bigFlag: false,
    alt: "Fruit Name Jump",
    viewNum: 867,
    score: "7.6bn",
  },
]);

const navigateToGame = (index) => {
  router.push({ name: "play", query: { gameId: index } });
};
const clickMenu = (item) => {
  router.push(item.skipUrl);
};
const gameId = ref("");
const frameUrl = ref("");
/**
 * adsense
 */
const clientId = process.env.VUE_APP_ADSENSEID;
const clientslotId = process.env.VUE_APP_ADSENSESLOTID;

const loadAds = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  // 创建并配置 <ins> 元素
  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";

  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);
  const adContainer = document.getElementById("ad-container");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const loadAds2 = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";
  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);

  const adContainer = document.getElementById("ad-container2");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
onMounted(() => {
  // loadAds();
  // loadAds2();
});
watch(
  () => route.query.gameId,
  (newGameIdValue) => {
    if (newGameIdValue) {
      gameId.value = newGameIdValue;
      frameUrl.value = `https://xmxmy.com/gameTesting/${newGameIdValue}/index.html`;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      console.log(newGameIdValue, "newGameIdValue");
    }
  }
);
</script>

<style lang="scss" scoped>
.premium-block {
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.premium-block.premium-block--register {
  align-items: center;
}

.premium-block--register .premium-block__link-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.premium-block--register .premium-block__link-wrapper > a {
  margin-bottom: 16px;
}

.premium-block--register .premium-block__link-wrapper > span {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
}

.premium-block--register .premium-block__text-wrapper {
  text-align: center;
}

.premium-block--register .premium-block__text-wrapper h2 {
  width: 100%;
}

.premium-block.background-1 {
  background: linear-gradient(to right, #040404, 70%, transparent),
    url("https://staticdelivery.nexusmods.com/Images/ad_bg_1.png") right/60%
      no-repeat,
    #040404;
}

.premium-block.background-2 {
  background: linear-gradient(to right, #040404, 70%, transparent),
    url("https://staticdelivery.nexusmods.com/Images/ad_bg_2.png") right/60%
      no-repeat,
    #040404;
}

.premium-block.hidden {
  display: none;
}

.premium-block::before {
  top: 0;
}

.premium-block::after {
  bottom: 0;
}

.premium-block__text-wrapper {
  text-align: left;
  width: 100%;
  margin-bottom: 16px;
}

.premium-block__link-wrapper {
  text-align: left;
}

.premium-block__text-wrapper h2 {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 24px;
  width: 80%;
}

.premium-block__text-wrapper p {
  font-weight: 400;
  color: rgba(225, 225, 225, 0.8);
}

.premium-block__link-wrapper > a.rj-btn {
  width: 200px;
}

.premium-block--register .premium-block__link-wrapper > a.rj-btn {
  width: 100%;
}

.premium-block__link-wrapper > a.rj-btn i:last-child {
  margin-left: 8px;
}

@media (min-width: 768px) {
  .premium-block {
    padding: 32px 16px;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .premium-block__text-wrapper {
    width: 70%;
    margin-bottom: 0;
  }

  .premium-block--register .premium-block__text-wrapper {
    width: 50%;
    text-align: left;
  }

  .premium-block--register .premium-block__link-wrapper > a.rj-btn {
    width: 200px;
  }
}

@media (min-width: 1000px) {
  .premium-block__text-wrapper {
    text-align: center;
  }

  .premium-block--register .premium-block__text-wrapper {
    width: 50%;
    text-align: center;
  }

  .premium-block__link-wrapper {
    text-align: center;
  }

  .premium-block__text-wrapper h2 {
    font-size: 32px;
    width: 100%;
  }

  .premium-block__text-wrapper br {
    display: none;
  }
}

.notification {
  display: flex;
  font-size: 14px;
  color: white;
  width: 100%;
  justify-content: space-between;
}

.notification-link {
  width: 80%;
}

.notification-category-icon-wrapper {
  width: 15%;
}

.notification-category-specific-icon {
  border-radius: 20px;
  object-fit: cover;
  object-position: center;
}

.notification-category-generic-icon,
.notification-category-specific-icon {
  width: 30px;
  height: 30px;
}

.notification-content {
  width: 85%;
}

.notifications-list ul li .notification-bold,
.notifications-list ul li .text-primary,
.notifications-list ul li .text-primary-moderate {
  display: inline;
  font-weight: 600;
  color: var(--rj-orange-font);
}

.notifications-list ul li .notification-content > div:first-child {
  min-height: 40px;
}

.notification-row {
  margin-bottom: 10px;
}

.notification-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.notification-icon {
  border-radius: 21px;
  height: 42px;
  width: 42px;
  background-repeat: no-repeat;
  background-size: 42px 42px;
  margin-right: 10px;
}

.notification-indicator-wrapper {
  height: 100%;
  width: 12%;
}

.notification-indicator-box {
  visibility: hidden;
  width: 24px;
  height: 24px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.expanding-hover {
  position: relative;
}

.expanding-hover::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  height: 0;
  width: 0;
  border-radius: 100%;
  background-color: var(--rj-white-30);

  transition-property: height, width, top, left;
  transition-duration: 0.25s;
  transition-timing-function: ease-in-out;
}

.expanding-hover:hover::before {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.notification-wrapper.notification-unread .notification-indicator-box {
  visibility: visible;
}

.notification-indicator {
  border-radius: 4px;
  width: 8px;
  height: 8px;
  margin: auto;
  background: var(--rj-orange-font);
  padding: 0;
  border: 0;
}

.icons-row {
  display: flex;
}

.notification-menu-wrapper {
  width: 8%;
  display: flex;
  height: 24px;
  justify-content: center;
}

.notification-menu-button {
  width: 24px;
  background: none;
  border: 0;
  padding: 0;
}

.notification-menu-hidden {
  display: hidden;
}

.notification-menu {
  background-color: var(--rj-nexusblack-high-contrast);

  display: none;
  font-family: Montserrat;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  z-index: 1;
  opacity: 1;
  border-radius: 4px;
  border: 1px solid #3e413f;
}

.notification-menu-row {
  display: flex;
  height: 48px;

  align-items: center;
  box-sizing: border-box;
  padding: 12px 10px 12px 16px;
  gap: 10px;
}

.notification-menu-row.notification-remove {
  margin-top: 16px;
  position: relative;
}

.notification-menu-row.notification-remove:before {
  content: "";
  background: #3c3f44;
  height: 1px;
  padding: 0;
  position: absolute;
  top: -8px;
  left: 7px;
  right: 7px;
}

.notification-menu-row:hover {
  background-color: var(--rj-white-05);
}

.notification-mark-as-read,
.notification-mark-as-unread {
  display: none;
}

.notification-wrapper.notification-unread .notification-mark-as-read {
  display: flex;
}

.notification-wrapper.notification-read .notification-mark-as-unread {
  display: flex;
}

.notification-menu-icon-wrapper {
  padding: 0;
  margin: 0;
  width: 24px;
}

.notification-menu-icon {
  padding: 0;
  margin: 0;
  width: 24px;
}

.notification-menu-text {
  background: none;
  border: 0;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  letter-spacing: 1.4px;
  white-space: nowrap;
}

.notification-read .notification {
  opacity: 0.5;
}

@media (min-width: 1024px) {
  .notification-category-generic-icon,
  .notification-category-specific-icon {
    width: 35px;
    height: 35px;
  }

  .notification-wrapper:hover .notification-menu-wrapper,
  .notification-wrapper:focus-within .notification-menu-wrapper {
    visibility: visible;
  }

  .notification-menu-wrapper {
    visibility: hidden;
  }
}

.notification-menu {
  position: absolute;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  top: 47px;
  right: 20px;
}

.collections-banner-outer-wrapper-trigger .collections-banner-wrapper {
  background: #2d2d2d;
  padding: 32px 16px;
}

.collections-banner {
  position: relative;
  width: 100%;
  background: #0555b8;
  color: white;
  height: 68px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 16px;
  font-family: montserrat;
  cursor: pointer;
  gap: 12px;
  font-size: 18px;
  letter-spacing: 0.15px;
}

.collections-banner > span {
  position: relative;
}

.collections-banner:hover {
  color: white;
}

.collections-banner__splash {
  display: none;
  position: absolute;
  right: 4px;
  top: 4px;
  bottom: 4px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 60px 100%);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
  width: calc(100% - 600px);
  max-width: 644px;
}

.collections-banner__splash-image {
  height: 100%;
  object-fit: cover;
  object-position: 0%;
}
.game-frame {
  background-color: #2d2d2d;
  width: 100%;
  height: 700px;
}

@media only screen and (min-width: 768px) {
  .collections-banner__splash {
    display: block;
  }
}
@media screen and (orientation: portrait) {
  .game-frame {
    background-color: #2d2d2d;
    width: 100%;
    height: 500px;
  }
  .rj-search-button {
    display: none;
  }
  .collections-banner {
    span {
      font-size: 0.5rem;
    }
    .material-icons {
      font-size: 0.5rem;
    }
  }
}
</style>
